import React from 'react';
import { RouteComponentProps } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { OfferItemPage } from './OfferItemPage/OfferItemPage';
import { OfferListPage } from './OfferListPage/OfferListPage';
import { NewOfferItemPage } from './NewOfferItemPage/NewOfferItemPage';

export function OffersRouter(props: RouteComponentProps) {
  const { match } = props;
  return (
    <Switch>
      <Route exact path={`${match.path}`} component={OfferListPage} />
      <Route exact path={`${match.path}/new`} component={NewOfferItemPage} />
      <Route path={`${match.path}/:id`} component={OfferItemPage} />
    </Switch>
  );
}
